import { CSSProperties } from 'react'

export const previewImageStyles: CSSProperties = {
  maxWidth: '100%',
  height: 'auto',
  objectFit: 'contain',
}

export const darkModalBodyStyles = {
  padding: '20px',
  maxWidth: '900px',
  maxHeight: '900px',
}
